import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'lib-survey-page-logo',
  templateUrl: './survey-page-logo.component.html',
  styleUrls: ['./survey-page-logo.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class SurveyPageLogoComponent {
  @Input() title: string | SafeHtml | null | undefined;
  @Input() subtitle: string | SafeHtml | null | undefined;
  @Input() description: string | SafeHtml | null | undefined;
}
